import { render, staticRenderFns } from "./CandidateSummary.vue?vue&type=template&id=5808bcc5&"
import script from "./CandidateSummary.vue?vue&type=script&lang=js&"
export * from "./CandidateSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports